import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { useRequest } from 'redux-query-react';
import consentRequest, { ICustomerConsentResponse } from 'components/Gdpr/requests/consentRequest';
import { CookieType } from 'components/Gdpr/enums/CookieType';

export interface IGdprConsent {
    isFinished: boolean;
    customerConsent?: ICustomerConsentResponse;
    hasConsent: (cookieType: CookieType) => boolean;
}

const mapStateToProps = (state) => state.entities.customerConsentRequest as ICustomerConsentResponse;

export const useGdprConsent = (): IGdprConsent => {
    const [{ isFinished }] = useRequest(consentRequest(Cookies.get('gdpr_cookie_token') ?? ''));
    const customerConsent = useSelector(mapStateToProps);

    const hasConsent = (cookieType: CookieType): boolean => {
        if (customerConsent?.errors) {
            return false;
        }

        return customerConsent?.data?.find((consent) => consent.code === cookieType)?.status === true;
    };

    return { isFinished, customerConsent, hasConsent };
};
